import { Action } from 'redux';
import { ContractBranch } from '../../../models/Entities/Contracts/ContractBranch';
import { ContractBranchState, ContractBranchUnloadState } from '../../states/ContractBranchState';


export default function ContractBranchesDeleteReducer(
  state: ContractBranchState | undefined,
  action: Action
): ContractBranchState {
  const currentState = state ?? ContractBranchUnloadState;
  const a: any = action;
  let CurrentBranchContract: ContractBranch | undefined;

  switch (a.type) {
    case 'CONTRACTBRANCH_DELETE_REQUEST_ACTION':
      return {
        ...currentState,
        isDeletingOne: true,
        successDeletingOne: undefined,
        failOnDeletingOne: false,
      };
    
    case 'CONTRACTBRANCH_DELETE_RECEIVE_ACTION':
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: true,
        failOnDeletingOne: false,
      };
    
    case 'CONTRACTBRANCH_DELETE_ERROR_ACTION':
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: false,
        failOnDeletingOne: true,
        error: a.error,
      };
    
    default:
      return currentState;
  }
}
